module.exports = __webpack_public_path__ + "img/service_1.53b24a25.png";